import { useDispatch, useSelector } from "react-redux"
import { getTalkedToDoctor } from "reducers/userInfo"
import { updateTalkedToDoctor } from "actions/userActions"
import { FleLayout } from "components/views/fle/FleLayout"
import { TopSection } from "components/views/fle/TopSection"
import { BackArrow, SkipArrow, SwitchH2ToBodyLarge } from "components/views/fle/Molecules"
import { Spacer } from "components/views/atoms/Atoms"
import YesNoChoices from "content/YesNoChoices"
import { Button } from "components/views/atoms/buttons/Button"
import { FleLinkWrapper } from "components/views/atoms/Links"
import React from "react"

const JourneyTalkedToDoctorContainer = ({ title, next, history }) => {
  const talkedToDoctor = useSelector((state) => getTalkedToDoctor(state))
  const dispatch = useDispatch()

  const submitTalkedToDoctor = async (talkedToDoctor) => {
    await dispatch(updateTalkedToDoctor(talkedToDoctor, null))
    history.push(next)
  }

  return (
    <FleLayout>
      <TopSection progressStep={4} leftOrBackArrow={<BackArrow />} />
      <SwitchH2ToBodyLarge>{title}</SwitchH2ToBodyLarge>
      <Spacer height={3} />
      {YesNoChoices.map(({ id, label }) => (
        <div key={id} className="flex flex-row justify-end w-100 mb1">
          <Button bold={false} onClick={() => submitTalkedToDoctor(id)}>
            {label}
          </Button>
        </div>
      ))}
      <FleLinkWrapper>
        <SkipArrow to={next} />
      </FleLinkWrapper>
    </FleLayout>
  )
}

export { JourneyTalkedToDoctorContainer }
